import { makeStyles } from "@/utils"
import { colors } from "@/styles/colors"
import { FONT } from "@/styles/fonts"

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(1.5, 2),
		marginBottom: theme.spacing(1),
		width: "100%",
		boxSizing: "border-box"
	},
	containerCollapsed: {
		padding: theme.spacing(1.5, 0),
		display: "flex",
		justifyContent: "center"
	},
	button: {
		width: "100%",
		minHeight: "unset",
		minWidth: "unset",
		padding: theme.spacing(1.25, 2),
		fontSize: FONT.size.small2,
		fontWeight: 700,
		color: colors.purple[500],
		borderColor: colors.purple[500],
		borderRadius: theme.spacing(1),
		textTransform: "none",
		"&:hover": { backgroundColor: colors.purple[100] }
	},
	buttonCollapsed: {
		width: "auto",
		padding: theme.spacing(1)
	}
}))

export default useStyles
